import requests from '../../utils/requests'
import { config } from '../../config/global'
import { Country } from '../../global/types'

export const getCountriesAPI = (): Promise<Country[]> =>
  requests.get('countries', { baseUrl: config.iamBaseUrl })
